import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { Redirect } from 'react-router-dom'

import { LanInfoRecoger } from './LanInfoRecoger'


export class LanRecogerEnvio extends Component {
    displayName = LanRecogerEnvio.name

    constructor(props) {
        super(props);
        this.state = {
            divisiones: [],
            loading: true,
            idPais: this.props.location.state.idPais,
            idCiudad: this.props.location.state.idCiudad,
            token: this.props.location.state.token,
            idModulo: this.props.location.state.idModulo,
            idDivision: 0,
            numeroGuia: this.props.location.state.numeroGuia, 
            guardar: false,
            volver: false,
            pagina: 0,
            maxPerPag: 3,
            primera: true,
            ultima: false,
            infoRecoger: false,
            funcion: this.props.location.state.funcion,

            mensajesBtns: this.props.location.state.mensajesBtns,
            accion: this.props.location.state.accion
        };
    }

    componentDidMount() {
        const pais = this.state.idPais;
        const ciudad = this.state.idCiudad;
        fetch(window.env.API_DOMAIN_ADDR + '/api/Parametros/DivisionEntrega/' + pais + '/' + ciudad, {
                headers: {
                    'authorizedtoken': this.state.token,
                    'user': window.env.API_USER,
                    'refnumber': this.state.numeroGuia
                }
            })
            .then(response => response.json())
            .then(data => {
                var arrDivisiones = [];
                for (var i = 0; i < data.length; i++) {
                    
                    arrDivisiones.push(
                        <div key={i} onClick={this.selectDiv} id={"itemDiv" + i} className="itemUbicacion" iddivision={data[i].iD_DIVISION}>
                            <label className="title">{data[i].nombrE_DIVISION}</label>
                            <div className="info"><div><img src="/media/images/horario.png" /></div><div className="infoText"><label>{data[i].horarioS_ATENCION}</label></div></div>
                            <div className="info"><div><img src="/media/images/ubicacion.png" /></div><div className="infoText"><label>{data[i].direccioN_DIVISION}</label></div></div>
                        </div>
                    );
                }
                this.setState({ divisiones: arrDivisiones, loading: false });
            });
    }

    setGuardar = () => {
        if (this.state.idDivision > 0) {//Valida si se ha seleccionado division
            this.setState({
                guardar: true
            });
        } else {
            alert("No ha seleccionado ninguna división para recoger su envío");
        }
    }

    setVolver = () => {
        this.setState({
            volver: true
        });
    }
    
    //Retorna el array de divisiones filtrado por items por pagina
    setFilters(ctx, item) {
        return ctx.state.divisiones.indexOf(item) >= (ctx.state.pagina * ctx.state.maxPerPag) && ctx.state.divisiones.indexOf(item) < ((ctx.state.pagina * ctx.state.maxPerPag) + ctx.state.maxPerPag);
    }

    //Aplica el filtro sobre array de divisones sobre index de elemento
    filterDivisiones(ctx) {
        if (this.state.divisiones.length > 1) {
            const filtrado = this.state.divisiones.filter(this.setFilters.bind(this, ctx));
            return filtrado;
        } else {
            return this.state.divisiones;
        }
    }

    //Selecciona division
    selectDiv = (e) => {
        var elem;
        if (e.target.className.toLowerCase() === "itemubicacion" && e.target !== undefined) {
            elem = e.target;
        } else if (e.target.parentNode.className.toLowerCase() === "itemubicacion"){
             elem = e.target.parentNode;
        } else if (e.target.parentNode.parentNode.className.toLowerCase() === "itemubicacion") {
            elem = e.target.parentNode.parentNode;
        } else if (e.target.parentNode.parentNode.parentNode.className.toLowerCase() === "itemubicacion") {
            elem = e.target.parentNode.parentNode.parentNode;
        }
        this.resetPages();
        if (elem != null) {
            elem.className = "itemUbicacion active";
            this.setState({
                idDivision: elem.getAttribute("iddivision")
            });
        }
    }

    //Limpia division seleccionada
    resetPages = () => {
        this.setState({
            idDivision: 0
        })
        for (var i = (this.state.pagina * this.state.maxPerPag); i <= (this.state.pagina * this.state.maxPerPag) + this.state.maxPerPag; i++) {
            var a = document.getElementById("itemDiv" + i);
            if (a !== null) {
                a.className = "itemUbicacion";
            }
        }
    }

    //Primera pagina
    setFirstPage = () => {
        this.setState({
            pagina: 0,
            primera: true,
            ultima: false
        });
        this.resetPages();
    }

    //Ultima pagina
    setLastPage = () => {
        this.setState({
            pagina: Math.ceil((this.state.divisiones.length - this.state.maxPerPag) / this.state.maxPerPag),
            ultima: true,
            primera: false
        });
        this.resetPages();
    }

    //Pagina adelante
    setOneUp = () => {
        this.setState({
            pagina: (this.state.pagina < Math.ceil((this.state.divisiones.length - this.state.maxPerPag) / this.state.maxPerPag) ? this.state.pagina + 1 : this.state.pagina),
            primera: false
        });
        this.resetPages();
    }

    //Pagina atras
    setOneDown = () => {
        this.setState({
            pagina: (this.state.pagina > 0 ? this.state.pagina - 1: this.state.pagina),
            ultima: false
        });
        this.resetPages();
    }


    setInfoRecoger = () => {
        this.setState({ infoRecoger: true });
    }

    closeInfoRecoger = () => {
        this.setState({
            infoRecoger: false
        });
    }

    static renderInfo(c) {
        return (
            <LanInfoRecoger idModulo={c.state.idModulo} token={c.state.token} numeroGuia={c.state.numeroGuia} onClick={c.closeInfoRecoger.bind(c)}></LanInfoRecoger>
        );
    }

    static renderDivisiones(divisiones, c) {
        return (
            <div className="contentBody">
                <div className="header">
                    <img className="movil" src="/media/images/Encabeza_toma_decision.png" />
                    <img className="escritorio" src="/media/images/escritorio/confirmaciones_completo.png" />
                </div>
                <div className="content">
                    <form>
                        <Grid fluid className="grid">
                            <Row>
                                <Col className="gridHeaderImg">
                                    <img src="/media/images/Confirmaciones.png" />
                                </Col>
                            </Row>
                        </Grid>
                        <Grid fluid className="selUbicacion">
                            <Row className="banner">
                                <Col sm={10} className="bannerCol">
                                    <img src="/media/images/Recoger_envio.png" />
                                    <span className="texto"><h1>DESEO RECOGER MI ENVÍO</h1><br /><h2>Selecciona el lugar en dónde deseas recoger tu envío:
                                            </h2></span>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <div className="infoRecoger" onClick={c.setInfoRecoger}>
                                        <img src="/media/images/informacion.png" />
                                        <label>Información importante</label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    {divisiones}
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" style={{ visibility: c.state.primera == true ? 'hidden' : 'visible' }} onClick={c.setFirstPage} className="main" value="<<" />
                                    <input type="button" onClick={c.setOneDown} className="secundary" value="<" />
                                    <input type="button" onClick={c.setOneUp} className="secundary" value=">" />
                                    <input type="button" style={{ visibility: c.state.ultima == true ? 'hidden' : 'visible' }} onClick={c.setLastPage} className="main" value=">>" />
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={10} className="gridCol t">
                                    <input type="button" onClick={c.setVolver} className="secundary" value={c.state.mensajesBtns[1]} />
                                    <input type="button" onClick={c.setGuardar} className="main" value={c.state.mensajesBtns[0]} />
                                </Col>
                            </Row>
                        </Grid>
                        <hr />
                    </form>
                </div>
            </div>
        );
    }

    render() {
        let content = this.state.loading
            ? <p><em>Loading...</em></p>
            : LanRecogerEnvio.renderDivisiones(this.filterDivisiones(this), this);

        //En caso de info recoger
        let contentAdd = this.state.infoRecoger
            ? LanRecogerEnvio.renderInfo(this)
            : "";

        //En caso de volver
        if (this.state.volver == true) {
            return (
                <Redirect to={"/?numero_guia=" + this.state.numeroGuia + "&modulo=" + this.state.idModulo + "&token=" + this.state.token} />
            );
        }

        //En caso de guardar
        if (this.state.guardar == true) {
            return <Redirect to={{
                pathname: '/MensajeFinal',
                state: { numeroGuia: this.state.numeroGuia, idPais: this.state.idPais, idCiudad: this.state.idCiudad, idDivision: this.state.idDivision, token: this.state.token, idModulo: this.state.idModulo, funcion: this.state.funcion, accionGuardar: this.state.accion}
            }}
            />;
        }
        return (
            <div>
                {content}
                {contentAdd}
            </div>
        );
    }
}
